module.exports = __webpack_public_path__ + "img/28.0eca0012.svg";